module.exports = __webpack_public_path__ + "static/img/akamai.8e6d5dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/akamai.png
// module id = HiyX
// module chunks = 1